import React from "react";
import { NextPage } from "next";
import AuthPage from "../../../common/components/PageWrappers/AuthPage";
import Join from "../../../modules/Authorization/Join";

const JoinPage: NextPage = () => (
  <AuthPage>
    <Join />
  </AuthPage>
);

export default JoinPage;
